import { assertNever } from '@/helpers/utils';
import { Area } from '@/modules/floorplanDesign/types';

/**
 * Determines whether a distant connection (NEAREST) may be created between
 * two area types via the explicit distant-connection tool.
 *
 * For now everything is allowed but this will likely change...
 */
export const isDistconAllowedBetweenAreaTypes = (
  typeA: Area['areaType'],
  typeB: Area['areaType'],
): boolean => {
  if (typeA === 'MANUAL' || typeB === 'MANUAL') return false;
  return true;
};

/**
 * Returns the set of area types that are valid targets for the distant-connection tool
 * when the source area has the given type.
 */
export const getValidDistconTargetAreaTypes = (type: Area['areaType']): Area['areaType'][] => {
  // for now everything is allowed but this will likely change...
  switch (type) {
    case 'HIGHWAY':
      return ['HIGHWAY', 'RACKING', 'SINGULAR', 'STATIONARY'];

    case 'RACKING':
      return ['HIGHWAY', 'RACKING', 'SINGULAR', 'STATIONARY'];

    case 'SINGULAR':
      return ['HIGHWAY', 'RACKING', 'SINGULAR', 'STATIONARY'];

    case 'STATIONARY':
      return ['HIGHWAY', 'RACKING', 'SINGULAR', 'STATIONARY'];

    case 'MANUAL':
      return [];

    default:
      return assertNever(type);
  }
};
